<template>
    <gofix-card :title="titleCard">
        <template slot="gofixCard:right_header">
            <div class="d-flex justify-content-end align-items-center">
                <gofix-button label="Save" @click="save" :loading="loading"></gofix-button>
            </div>
        </template>
        <b-row v-bind:class="{'run-loading': loadingData}">
            <b-col md="6">
                <gofix-form-input
                    label="User Defined Field 1" 
                    v-model="data.user_defined_field_1">
                </gofix-form-input>
            </b-col>
            <b-col md="6">
                <gofix-form-input
                    label="User Defined Field 2" 
                    v-model="data.user_defined_field_2">
                </gofix-form-input>
            </b-col>
            <b-col md="6">
                <gofix-form-input-date
                    label="User Defined Field 3" 
                    v-model="data.user_defined_field_3">
                </gofix-form-input-date>
            </b-col>
            <b-col md="6">
                <gofix-form-input-date
                    label="User Defined Field 4" 
                    v-model="data.user_defined_field_4">
                </gofix-form-input-date>
            </b-col>
            <b-col md="6">
                <gofix-form-input
                    label="User Defined Field 5" 
                    v-model="data.user_defined_field_5">
                </gofix-form-input>
            </b-col>
            <b-col md="6">
                <gofix-form-input
                    label="User Defined Field 6" 
                    v-model="data.user_defined_field_6">
                </gofix-form-input>
            </b-col>
        </b-row>
    </gofix-card>
</template>
<script>
    import moment from 'moment';
    export default {
        name: 'user_defined_fields',
        components: {},
        props: ['property_id'],
        data() {
            return {
                data: {
                    user_defined_field_1: null,
                    user_defined_field_2: null,
                    user_defined_field_3: null,
                    user_defined_field_4: null,
                    user_defined_field_5: null,
                    user_defined_field_6: null,
                },
                loading: false,
                loadingData: false,
            }
        },
        watch: {
            property_id: function(val){
                this.getCustomField();
            }
        },
        computed: {
            titleCard() {
                return ' ';
            }
        },
        created() {
            this.getCustomField();
        },
        methods: {
            async getCustomField() {

                this.loadingData = true
                this.data.user_defined_field_1 = null
                this.data.user_defined_field_2 = null
                this.data.user_defined_field_3 = null
                this.data.user_defined_field_4 = null
                this.data.user_defined_field_5 = null
                this.data.user_defined_field_6 = null

                if(this.property_id) {
                    let param = {
                        property_id: this.property_id,
                    }

                    await this.$store.dispatch("PropertyController/getCustomFieldProperties", param)
                    .then(response => {
                        this.data.user_defined_field_1 = response.user_defined_field_1
                        this.data.user_defined_field_2 = response.user_defined_field_2

                        if(response.user_defined_field_3) {
                            this.data.user_defined_field_3 = moment(response.user_defined_field_3).toDate()
                        }
                        
                        if(response.user_defined_field_4) {
                            this.data.user_defined_field_4 = moment(response.user_defined_field_4).toDate()
                        }

                        this.data.user_defined_field_5 = response.user_defined_field_5
                        this.data.user_defined_field_6 = response.user_defined_field_6
                        
                        this.loadingData = false
                    })
                    .catch(err => {
                        this.loadingData = false
                    })
                }

                this.loadingData = false
            },
            save() {
                if(!this.property_id) {
                    return this.$alertNotification("Please select Property", "danger");
                }

                if(!this.$route.params.id) {
                    return this.$alertNotification("Please select Contract", "danger");
                }

                let fm_user_defined_field_3 = null
                let fm_user_defined_field_4 = null
                
                if(this.data.user_defined_field_3) {
                    fm_user_defined_field_3 = moment(this.data.user_defined_field_3).format("YYYY-MM-DD")
                }
                
                if(this.data.user_defined_field_4) {
                    fm_user_defined_field_4 = moment(this.data.user_defined_field_4).format("YYYY-MM-DD")
                }

                let request = {
                    user_defined_field_1: this.data.user_defined_field_1,
                    user_defined_field_2: this.data.user_defined_field_2,
                    user_defined_field_3: fm_user_defined_field_3,
                    user_defined_field_4: fm_user_defined_field_4,
                    user_defined_field_5: this.data.user_defined_field_5,
                    user_defined_field_6: this.data.user_defined_field_6,
                    property_id: this.property_id,
                    contract_id: this.$route.params.id
                }
                
                this.$store.dispatch(`PropertyController/saveCustomFieldProperties`, request)
                .then(response => {
                    return this.$alertNotification("Successfully updated", "success");
                })
                .catch(err => {
                    return this.$alertNotification(err.response.data.error.message.error, "danger");
                })
            }
        }
    }
</script>
